import {DISABLE_EDIT_REWARD_STATUS} from '@/utils/constants/rewardsConstants';

/**
 * Helper function to determine reward flow mode
 * @param {string|null|undefined} id - Reward ID from route params
 * @param {string|null|undefined} status - Reward status
 * @returns {'create'|'edit'|'view'} Flow mode
 */
export const getRewardFlowMode = (id, status) => {
  if (!id) return 'create';

  const normalizedStatus = status?.toUpperCase?.();
  const isViewOnly =
    !!normalizedStatus && DISABLE_EDIT_REWARD_STATUS.includes(normalizedStatus);

  return isViewOnly ? 'view' : 'edit';
};
